import { ItemBrand } from "./item-brand.model";

export class ItemRange {
  id: number;
  name: string;
  itemBrandName: string;
  itemBrandId: number;
  itemBrand: ItemBrand;
}
